import { AUTHORITIES } from '@app/constants/authorities'
import { LOADING } from '@app/constants/redux-state'
import useLocalization from '@app/hooks/useLocalization'
import { IEmployeeEducation } from '@app/interfaces/employee/employee-education'
import EmployeeEducationForm from '@app/pages/reference-book-page-details/employee-education/components/employee-education-form/employee-education-form'
import { getEmployeeEducations } from '@app/store/actions/employee-education-actions'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { setDocumentTitle } from '@app/utils/set-document-title/set-document-title'
import { Card, Table, Tag } from 'antd'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'

interface props {
  _employeeEducations: IEmployeeEducation[]
  _state: string
}

const ReferenceBookEmployeeEducation: React.FC<props> = ({
  _employeeEducations,
  _state,
}) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const { localizeData } = useLocalization()
  setDocumentTitle(t('employeeEducation.title'))

  useEffect(() => {
    const source = axios.CancelToken.source()
    if (isEmpty(_employeeEducations))
      dispatch(getEmployeeEducations({ source }, t('employeeEducation.error')))
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [])

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('employeeEducation.employeeEducation'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('general.status'),
      dataIndex: 'status',
      key: 'status',

      render: (tags) => (
        <>
          {tags.map((tag) => {
            const color = tag === true ? 'green' : 'volcano'
            const text =
              color === 'green' ? t('general.active') : t('general.inActive')
            return (
              <Tag color={color} key={tag}>
                {text}
              </Tag>
            )
          })}
        </>
      ),
    },
    {
      title: t('general.action'),
      key: 'action',
      render: (text, record) =>
        rolesChecker([
          AUTHORITIES.ADMIN,
          AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
        ]) ? (
          <EmployeeEducationForm
            edit={true}
            employeeEducation={record.employeeEducation}
          />
        ) : null,
    },
  ]

  const data = !isEmpty(_employeeEducations)
    ? _employeeEducations.map((employeeEducation) => {
        return {
          key: employeeEducation.id,
          id: employeeEducation.id,
          name: localizeData(employeeEducation?.data)?.name,
          status: [employeeEducation.status],
          employeeEducation: employeeEducation,
        }
      })
    : []
  return (
    <>
      <Card
        extra={
          rolesChecker([
            AUTHORITIES.ADMIN,
            AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
          ]) ? (
            <EmployeeEducationForm />
          ) : null
        }
        title={t('employeeEducation.title')}
      >
        <Table
          pagination={false}
          loading={_state === LOADING}
          dataSource={data}
          columns={columns}
        />
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    _state: state.employeeEducation.state,
    _employeeEducations: state.employeeEducation.employeeEducations,
  }
}

export default connect(mapStateToProps)(ReferenceBookEmployeeEducation)
